import loggerService from '@/services/logger.service';
import { getServerTime } from '@/services/session.service';

export function getRecorderServerTimeDelta(): Promise<number> {
  // assume recorder time is always in sync with the backend server.
  return Promise.resolve(0);
}

export function getAttendeeUsersServerTimeDelta(): Promise<number> {
  return getServerTime().then(serverTimeResponse => {
    const serverUnixTimeStamp = serverTimeResponse.data['unix_timestamp'];
    const userLocalUnixTimeStamp = Math.floor(Date.now() / 1000);
    const serverAndUserTimeDelta = serverUnixTimeStamp - userLocalUnixTimeStamp;
    const timeDelta = serverAndUserTimeDelta * 1000;

    if (Math.abs(timeDelta) > 2000) {
      loggerService.warn('Time difference with server is high', timeDelta);
      loggerService.track('server-user-time-mismatch');
    }

    return timeDelta;
  });
}
